import { h, T, t, setVisible, domWithScope } from '@jsx6/jsx6'
import { phoneInput } from './phoneInput.js'
import {COUNTRY_CODES} from 'chat-util/countryCodes.js'

/**
 *
 * @param {ChatBox} chat
 * @param survey
 * @param isPreview
 * @returns Element
 */

export const chatSurvey = (chat, survey, isPreview) => {
  const isSurvey = chat.isChatbotSurvey
  const type = survey.type // SURVEY, CHAT_DIALOG
  const chatDialogType = type === 'CHAT_DIALOG' ? survey.originalSurveyType : 'Survey'
  let chatDialogTitle = chatDialogType === 'Survey' ? '' : survey.name 
  let chatDialogPromptText = survey.promptText || ''
  let submitBtnText = survey.sendButtonTextTrans?.[chat.options.lang] || survey.sendButtonText || t(`submit`)
  const itemsArray = survey.items || survey.questions || []
  let menuArray = survey.menu || []
  menuArray = menuArray.map(item => {
    item.surveyId = survey.id
    return item
  })

  if(survey.answer){
    setTimeout(() => {
      setLocalstoreSurveyValues(survey.answer)
      let submitted = chat.el.querySelector('.submitted')
      setVisible(submitted, true)
    }, 100)
  }
  
  let surveyBotStored = chat.surveyBotStored

  const setLocalstoreSurveyValues = (answer) => {
    let inputs = chat.el.getElementsByTagName('input')
    let txtareas = chat.el.getElementsByTagName('textarea')

    if(inputs.length){
      if(survey.answer) setElValue(inputs, answer)
      setElsReadOnly(inputs)
    }
    if(txtareas.length){
      if(survey.answer) setElValue(txtareas, answer)
      setElsReadOnly(txtareas)
    }
  }
  const submitSurvey = (evt)=>{
    let valid = true
    let singleTypes = []
    const parent = evt.target.parentNode.parentNode.parentNode
    let inputs = parent.getElementsByTagName('input')
    let txtareas = parent.getElementsByTagName('textarea')
    let selectedEls = parent.querySelectorAll('.selected')
    let selectEls = parent.querySelectorAll('.chatbot-option')
    let submitted = parent.querySelectorAll('.submitted')
    setVisible(submitted, true)
    itemsArray.forEach(item => {
      if (item.type === 'single') singleTypes.push(item)
    })

    let itemResponses = itemsArray
    itemResponses = itemResponses.map((item)=>{
      const validInputs = []
      for (let inp of inputs) {
        if(isSurvey){
          if(inp.getAttribute('data-item-id') === item.id?.toString()){
            if((item.type === 'RATE' || item.type === 'NUMERIC') && inp.checked) {
              surveyBotStored[item.name] = inp.checked
              validInputs.push(inp)
            }
          }
        } else {
          if(item.storeInto === inp.getAttribute('data-store-into')){
            surveyBotStored[item.storeInto] = inp.value
            validInputs.push(inp) 
          }
        }
      }
      for(let txt of txtareas){
        if(txt.getAttribute('data-item-id') === item.id?.toString()){
          validInputs.push(txt)
          surveyBotStored[item.name] = txt.value

        }
      }
      
      for(let sel of selectedEls) {
        if(sel.getAttribute('data-item-id') === item.id?.toString()) {
          let selectedVal = sel.innerHTML.replace(' ', '')
          selectedVal = selectedVal.charAt(0).toLowerCase() + selectedVal.slice(1)
          if(selectedVal){
            sel.value = sel.innerHTML
            validInputs.push(sel)
            surveyBotStored[item.name] = sel.innerHTML
          }
        }
      }


      if(validInputs.length){
        return {...item, inputs: validInputs}
      } else {
        valid = false
        return item
      }
    })


    if (!valid) return
    //if(!surveyBotStored.type) surveyBotStored.type = 'CHAT_DIALOG'
    if(!surveyBotStored.id) surveyBotStored.id = undefined
    if(survey.description) surveyBotStored.description = survey.description
    chat.setAnswerLocalStore(surveyBotStored)
    // TODO sanjin - Ovo ne moze ovako ovo je samo za demo sjebat ce se history
    delete surveyBotStored.type
    let answer = JSON.stringify({ type: "CHAT_DIALOG", vars: surveyBotStored })
    chat.setMessageInputAsReadonly(false)
    evt.target.innerHTML = t('submitted')
    evt.target.parentNode.remove()
    if(inputs.length) setElsReadOnly(inputs)
    if(txtareas.length) setElsReadOnly(txtareas)
    if(selectEls.length) setElsReadOnly(selectEls)
    if(isSurvey){
      chat.sendSurvey(isSurvey, itemResponses)
    } else {
      chat.sendMessage(answer)
    }
  }

  const setElsReadOnly = (elements) => {
    for (let el of elements) {
      el.setAttribute('readonly', true)
      el.setAttribute('disabled', true)
    }
  }

  const getMaxLength = (item) => {
    if(item.type === 'mail'){
      return 999
    }
    
    return item.max || 16
  }
  
  const checkBoxItem = item => {
    return (
      <div style="display:flex; align-items:center;">
        <input data-item-id={item.id}  style="height:15px; min-width: 15px; width: 15px;" type={item.type} maxlength={()=>getMaxLength(item)} data-store-into={item.storeInto} required={item.mandatory} onchange={toggleSubmit} />
        <a target="_blank" href={item.link}>{item.label}</a>
      </div>
    )
  }
  const inputItem = item => {
    const placeholder = item.type === 'mail' ? T`placeholder_email`: item.storeInto === 'taxNumber' ? T`placeholder_taxNumber`: ''
    return (
      <div class="form-line">
        <input data-item-id={item.id} class={`label_${item.label}`} type={item.type === 'mail'? 'email': item.type} maxlength={()=>getMaxLength(item)} data-store-into={item.storeInto} required={item.mandatory} onkeyup={toggleSubmit} placeholder={placeholder}/>
        <div class="error-message" hidden>
          {t`required_message`}
        </div>
      </div>
    )
  }

  const textItem = item => (
    <div class="form-line">
      <textarea data-item-id={item.id} class={`label_${item.label}`} placeholder={t`${item.label}`} onkeyup={toggleSubmit}></textarea>
      <div class="error-message" hidden>
        {t`required_message`}
      </div>
    </div>
  )
  const toggleOptions = (evt, opt, chat, menuArray, isPreview) => {
    if(isPreview){
      return
    }

    let parent = evt.target.parentNode.children
    for (let child of parent) {
      child.className = 'chatbot-option'
    }

    evt.target.classList.add('selected')
    if(menuArray && menuArray.length){
      let blockId = menuArray.find(menu => menu.label == opt)
      blockId.type = 'CHAT_DIALOG'
      // evt.target.closest(".chatbot-form").classList.add('answered')
      chat.sendMessage(blockId)
    }
    
    if(isSurvey){
      toggleSubmit(evt)
    }
  }
  const singleItem = (item, chat, menuArray, isPreview) => (
    <div class="chatbot-select">
      {item.options.map(opt => (
        <div
          data-item-id={item.id}
          class="chatbot-option"
          onclick={(evt) => toggleOptions(evt, opt, chat, menuArray, isPreview)}
          selector='--chatbot-button-bg,--chatbot-button-fg'>
          {t`${opt}`}
        </div>
      ))}
      <div class="error-message" hidden>
        {t`required_message`}
      </div>
    </div>
  )
  const numericItem = (item, chat, menuArray, isPreview) => {
    return <div class="form-line radio-recommend">
      <div class="form-inline form-radio">
        {item.answers.map((answer)=>{
          return <label class="checkcontainer">
            <input data-item-id={item.id} type="radio" name={item.name} value={answer.answer} selector="--checkbox-bg,--checkbox-fg" onclick={toggleSubmit}/>
            <span class="checkmark">{answer.answer}</span>
          </label>
        })}
      </div>
    </div>
  }

  const textItems = new Set(['regex','textarea','input', 'FREE_TEXT'])
  const rateItem = (item, chat, menuArray, isPreview) => (
    <div class="star-rating">
      <input data-item-id={item.id} type="radio" id="star5" name="rating" value="5" onclick={toggleSubmit}/>
      <label for="star5" class="star">&#9733;</label>

      <input data-item-id={item.id} type="radio" id="star4" name="rating" value="4" onclick={toggleSubmit}/>
      <label for="star4" class="star">&#9733;</label>

      <input data-item-id={item.id} type="radio" id="star3" name="rating" value="3" onclick={toggleSubmit}/>
      <label for="star3" class="star">&#9733;</label>

      <input data-item-id={item.id} type="radio" id="star2" name="rating" value="2" onclick={toggleSubmit}/>
      <label for="star2" class="star">&#9733;</label>

      <input data-item-id={item.id} type="radio" id="star1" name="rating" value="1" onclick={toggleSubmit}/>
      <label for="star1" class="star">&#9733;</label>
    </div>
  )
  function renderItem(item, chat, menuArray, isPreview){
    if(item.type === 'single' || item.type === 'OPTIONS') {
      return singleItem(item, chat, menuArray, isPreview)
    }

    if(item.type === 'RATE'){
      return rateItem(item, chat, menuArray, isPreview)
    }

    if(item.type === 'NUMERIC'){
      return numericItem(item, chat, menuArray, isPreview)
    }

    if(item.type === 'checkbox'){
      return checkBoxItem(item)
    }
    
    if(item.type === 'tel'){
      return phoneInput(item, toggleSubmit, chat)
    }
    
    if (['input', 'text', 'mail'].includes(item.type) && (!item.max || item.max < 100)) {
      return inputItem(item)
    }

    if(textItems.has(item.type)) {
      return textItem(item)
    }
  }
  const toggleSubmit = (evt) => {
    if (!evt || (evt && !evt.target)) return;
    let parent = null
    if(isSurvey){
      parent = chat.el.querySelector('[survey="survey"]');
    } else {
      parent = evt.target.parentNode.parentNode.parentNode
    }

    let valid = true;

    let inputs = parent.getElementsByTagName('input');
    if (chatDialogType === 'Collect') {
      for (let inp of inputs) {
        let isValid = true;
        const value = inp.value ? inp.value.trim() : '';
        if (inp.required) {
          if (inp.type === 'checkbox') {
            if (!inp.checked) {
              isValid = false;
            }
          } else {
            if (!value) {
              isValid = false;
            }
          }
        }

        if (value && inp.type !=='checkbox') {
          if (inp.minLength && value.length < inp.minLength) {
            isValid = false;
          }
        }

        if (inp.type === 'tel' && value) {
          const hasPlusSign = value.startsWith("+");
          const matchingCountry = COUNTRY_CODES.find(country =>
            value.startsWith(country.dial_code)
          );
          if (!hasPlusSign || !matchingCountry || value.length < 12) {
            isValid = false;
          }
        }
        
        if (inp.type === 'email' && value) {
          const emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,20})?$/;
          const emailValid = emailReg.test(value);
          if (!emailValid) {
            isValid = false;
          }
        }

        if (inp === evt.target) {
          if (!isValid) {
            inp.classList.add('error-style');
          } else {
            inp.classList.remove('error-style');
          }
        } else {
          inp.classList.remove('error-style');
        }


        if (!isValid) {
          valid = false;
        }
      }
    }else {
      const groupedInputs = {};
      for (let inp of inputs) {
        const name = inp.getAttribute('name') || 'collect';
        if (!groupedInputs[name]) {
          groupedInputs[name] = [];
        }
        groupedInputs[name].push(inp);
      }

      for (let name in groupedInputs) {
        const group = groupedInputs[name];
        let groupValid = false;

        for (let inp of group) {
          if (inp.type === 'radio' || inp.type === 'checkbox') {
            if (inp.checked) {
              groupValid = true;
              break;
            }
          } else {
            if (inp.value) {
              groupValid = true;
              break;
            }
          }
        }

        if (!groupValid) {
          valid = false;
          break;
        }
      }

      let selectDivs = parent.querySelectorAll('.chatbot-select');
      for (let selectDiv of selectDivs) {
        let options = selectDiv.querySelectorAll('.chatbot-option');
        let hasSelectedOption = false;

        for (let option of options) {
          if (option.classList.contains('selected')) {
            hasSelectedOption = true;
            break;
          }
        }

        if (!hasSelectedOption) {
          valid = false;
          break;
        }
      }

      
    }

    let submitBtnDiv = parent.querySelector('.buttons-line');
    setVisible(submitBtnDiv, valid);
  };

  function shouldPass(items) {
    // If `items` is not an array or is empty, return true immediately
    if (!Array.isArray(items) || items.length === 0) {
      return true;
    }

    // Define the required storeInto fields
    const requiredFields = ["email", "phoneNumber", "taxNumber"];

    // Extract storeInto values from each item
    const storeIntos = items.map(item => item.storeInto);

    // Check if all requiredFields exist in storeIntos
    const hasAllRequiredFields = requiredFields.every(field =>
      storeIntos.includes(field)
    );

    // If all fields are present, return false; otherwise return true
    return !hasAllRequiredFields;
  }
  
  return <div class="chatbot-form" survey={isSurvey}>
    <div class="menu-title" hidden={!chatDialogTitle}>
      {chatDialogTitle}
    </div>
    <div class="prompt-title">
      {chat.URLFromString(chatDialogPromptText)}
      <span class="submitted" icon="radio-check-2" hidden></span>
    </div>
    {itemsArray.map((item, key)=>{
      return <div key={key}>
          <div key={key} class="chatbot-form-label" hidden={item.type === 'checkbox'}>
          {menuArray.length ? '' : item.label}
        </div>
        {renderItem(item, chat, menuArray, isPreview)}
      </div>
    })}
    <div class="buttons-line" hidden>
      <a class="btn btn-primary" onclick={submitSurvey}>{submitBtnText}</a>
    </div>
  </div>
}